// utils
import apiSlice from "src/utils/api-slice";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    getBalance: "/transaction/wallet/info"
};

// ----------------------------------------------------------------------

const {
    useGetBalanceQuery,
    useLazyGetBalanceQuery
} = apiSlice.injectEndpoints({
    endpoints: builder => ( {
        getBalance: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "ReportBalance" ],
            query: () => `${ API_ENDPOINTS.getBalance }`,
            transformResponse: ({ data }, meta, arg) => data
        })
    } ),
    overrideExisting: true
});

// ----------------------------------------------------------------------

export {
    useGetBalanceQuery,
    useLazyGetBalanceQuery
};
